import React from 'react';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';

function Heading(){
    return (<header><h1><EmojiObjectsIcon />Notes App</h1></header>);
}

export default Heading;
